// extracted by mini-css-extract-plugin
export default {"wide":"Growth_wide__3VbdP"};